var _circle, _path, _g, _path2, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 140,
    r: 120,
    fill: "#F3F6FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.5 113L226 45M175.5 113L241.5 130M175.5 113L203 193.5M175.5 113L113 69.5M175.5 113L96 172.5M113 69.5L104.5 45M113 69.5L76 62M96 172.5L88 219.5M96 172.5H44M96 172.5L50 230",
    stroke: "#CBD6E8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_35209_77809)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 113,
    r: 30,
    fill: "#407EDB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 113,
    r: 32,
    stroke: "white",
    strokeWidth: 4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M243.5 223L203.5 195L195 216",
    stroke: "#CBD6E8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 241,
    cy: 130,
    r: 14,
    fill: "#7F57F1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 70,
    r: 8,
    fill: "#21B1BA"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 45,
    r: 4,
    fill: "#40DBAC"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 62,
    r: 4,
    fill: "#40DBAC"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 45,
    r: 11,
    fill: "#1A4586"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 203,
    cy: 194,
    r: 9,
    fill: "#9382FF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 243,
    cy: 223,
    r: 6,
    fill: "#AFA2FF"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 219,
    r: 6,
    fill: "#6EA5F8"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 230,
    r: 6,
    fill: "#6EA5F8"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 172,
    r: 6,
    fill: "#6EA5F8"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 217,
    r: 5,
    fill: "#AFA2FF"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 172,
    r: 16,
    fill: "#407EDB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_35209_77809",
    x: 138,
    y: 79,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_35209_77809"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_35209_77809",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon03);
export default __webpack_public_path__ + "static/media/info_icon03.94dca8306b24a704e67b26cbb264f86e.svg";
export { ForwardRef as ReactComponent };